import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { uuid } from './util';
import { useElementOnScreen } from './utility';
import './RedQuickLoLoMo.scss';
interface RedQuickLoLoMoState {
    scroll: any;
    width: any;
    disableNextPrev: boolean,
    startPosition: number;
    slideIndex: number;
    positionIndex: number;
    hovered: boolean;
    active: any;
    jumpTo: any;
}

interface RedQuickLoLoMoProps {
    itemsPerSlide: number,
    items: any[];
    itemContainerCls?: string;
    hovered: boolean;
    hoverTimeout?: number;
    onHover?: () => void;
    backgroundColor?: string,
    scaleActiveBy?: number,
    spaceBetween?: number,
    navPadding?: number,
    speedSlide?: number,
    infiniteScrolling?: boolean,
    speedMove?: number,
    itemProps?: (arg: any) => any,
    scale?: boolean,
    renderItem?: ({ item: { color }, index, setActive, removeActive }) => any,
    renderHandlePrev?: ({ goToPrev, ...p }) => any,
    renderHandleNext?: ({ goToNext, ...p }) => any,

}
export default class Lolomo extends React.Component<RedQuickLoLoMoProps, RedQuickLoLoMoState> {
    sliderInnerRef: any;
    timeoutEnter: any;
    timeoutLeave: any;
    jumpToTimeout: any;
    jumpToTimeoutCompletion: any;
    hoverEnter: any;
    hoverLeave: any;
    id: string;
    infiniteScrolling: boolean;
    constructor(props) {
        super(props);
        this.state = {
            startPosition: 0,
            jumpTo: undefined,
            slideIndex: 0,
            positionIndex: 0,
            hovered: false,
            disableNextPrev: false,
            width: 0,
            scroll: 0,
            active: null
        };

        this.sliderInnerRef = null;
        this.timeoutEnter = null;
        this.timeoutLeave = null;
        this.hoverEnter = null;
        this.infiniteScrolling = true;
        if (props.infiniteScrolling !== undefined) {
            this.infiniteScrolling = props.infiniteScrolling;
        }
        this.jumpToTimeoutCompletion = null;
        this.jumpToTimeout = null;
        this.hoverLeave = null;
        this.id = uuid();
    }
    componentDidMount() {
        this.setState({ width: 0, scroll: 0, active: null });
        window.addEventListener('resize', this.onResize);
        this.onResize();
    }
    componentDidUpdate(prevProps: Readonly<RedQuickLoLoMoProps>, prevState: Readonly<RedQuickLoLoMoState>, snapshot?: any): void {
        if (prevProps.hovered !== this.props.hovered) {
            if (this.props.hovered) {
                this.setHovered();
            }
            else {
                this.removeHovered();
            }
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }
    onResize = () => {
        if (this.sliderInnerRef) {
            let { slideIndex } = this.state;
            const width = this.sliderInnerRef?.getBoundingClientRect().width;
            const { itemsPerSlide } = this.props;
            const itemWidth = +(width / itemsPerSlide).toFixed(2);
            const offset = -itemWidth * this.props.items.length;
            let scroll = this.state.startPosition - (slideIndex * this.state.width);
            this.setState({ scroll, width });//, startPosition: offset
        }
        else {
            const width = document.body.clientWidth;
            this.setState({ width });//, startPosition: -width
        }
    };
    onSetSizeOnVisible = () => {
        if (this.sliderInnerRef) {
            const width = this.sliderInnerRef?.getBoundingClientRect().width;
            const { itemsPerSlide } = this.props;
            const itemWidth = +(width / itemsPerSlide).toFixed(2);
            const offset = -itemWidth * this.props.items.length;
            this.setState({ scroll: offset, width }); //, startPosition: offset
        }
        else {
            const width = document.body.clientWidth;
            this.setState({ scroll: -width, width });///, startPosition: -width 
        }
    };
    getNumberOfFrontBufferSlides() {
        return this.getNumberOfStraightSlides();
    }
    goToPrev = () => {
        if (this.state.disableNextPrev) {
            return;
        }
        let { width, slideIndex } = this.state;
        slideIndex -= 1;
        let disableNextPrev = false;
        clearTimeout(this.jumpToTimeoutCompletion);
        clearTimeout(this.jumpToTimeout);
        disableNextPrev = true;
        this.jumpToTimeout = setTimeout(() => {
            this.setState({
                jumpTo: true,
                positionIndex: this.state.positionIndex - 1,
                disableNextPrev: false
            });
            this.jumpToTimeoutCompletion = setTimeout(() => {
                this.setState({
                    disableNextPrev: false,
                    jumpTo: false
                })
            }, 10)
        }, this.props.speedMove * 2);

        this.setState({
            slideIndex,
            active: null,
            disableNextPrev
        });
    }
    _goToPrev = () => {
        if (this.state.disableNextPrev) {
            return;
        }
        let disableNextPrev = false;
        let { width, slideIndex } = this.state;
        const totalSlides = this.getNumberOfStraightSlides();
        slideIndex -= 1;
        let scroll = this.state.startPosition - (slideIndex * this.state.width);
        if (slideIndex === -1) {
            const { itemsPerSlide } = this.props;
            const itemWidth = +(width / itemsPerSlide).toFixed(2);
            const leftOverItems = this.props.items.length % itemsPerSlide;

            scroll = this.state.startPosition + (leftOverItems * itemWidth);
            clearTimeout(this.jumpToTimeoutCompletion);
            clearTimeout(this.jumpToTimeout);
            disableNextPrev = true;
            this.jumpToTimeout = setTimeout(() => {
                let scroll = this.state.startPosition - ((totalSlides - 1) * this.state.width);
                this.setState({
                    slideIndex: totalSlides - 1,
                    scroll,
                    jumpTo: true
                });
                this.jumpToTimeoutCompletion = setTimeout(() => {
                    this.setState({
                        disableNextPrev: false,
                        jumpTo: false
                    })
                }, 10)
            }, this.props.speedMove * 1);
        }
        this.setState({
            disableNextPrev,
            slideIndex: slideIndex,
            scroll,
            active: null,
        });
    };
    goToNext = () => {
        if (this.state.disableNextPrev) {
            return;
        }
        let { width, slideIndex } = this.state;
        slideIndex += 1;
        let scroll = -slideIndex * width;
        let disableNextPrev = false;
        clearTimeout(this.jumpToTimeoutCompletion);
        clearTimeout(this.jumpToTimeout);
        disableNextPrev = true;
        this.jumpToTimeout = setTimeout(() => {
            this.setState({
                jumpTo: true,
                positionIndex: this.state.positionIndex + 1,
                disableNextPrev: false
            });
            this.jumpToTimeoutCompletion = setTimeout(() => {
                this.setState({
                    disableNextPrev: false,
                    jumpTo: false
                })
            }, 10)
        }, this.props.speedMove * 2);

        this.setState({
            slideIndex,
            scroll,
            active: null,
            disableNextPrev
        });

    }

    _goToNext = () => {
        if (this.state.disableNextPrev) {
            return;
        }
        let { width, slideIndex } = this.state;
        slideIndex += 1;
        let scroll = this.state.startPosition - (slideIndex * this.state.width);
        const totalSlides = this.getNumberOfStraightSlides();
        let disableNextPrev = false;
        if ((totalSlides) === slideIndex) {
            const { itemsPerSlide } = this.props;
            const itemWidth = +(width / itemsPerSlide).toFixed(2);
            const leftOverItems = this.props.items.length % itemsPerSlide;
            scroll = this.state.startPosition - ((slideIndex - 1) * this.state.width + (leftOverItems * itemWidth));
            clearTimeout(this.jumpToTimeoutCompletion);
            clearTimeout(this.jumpToTimeout);
            disableNextPrev = true;
            this.jumpToTimeout = setTimeout(() => {
                this.setState({
                    slideIndex: 0,
                    scroll: this.state.startPosition,
                    jumpTo: true
                });
                this.jumpToTimeoutCompletion = setTimeout(() => {
                    this.setState({
                        disableNextPrev: false,
                        jumpTo: false
                    })
                }, 10)
            }, this.props.speedMove * 1);
        }

        this.setState({
            disableNextPrev,
            slideIndex,
            scroll: scroll,
            active: null,
        });
    };
    canGoToNext = () => {
        const index = Math.abs(this.state.scroll / this.state.width);
        const frontBuffer = this.getNumberOfFrontBufferSlides();
        const indexMax = frontBuffer + this.getNumberOfStraightSlides() - 1;
        return index < indexMax;
    };
    getNumberOfSlides = () => {
        const { items = [], itemsPerSlide } = this.props;
        return Math.max(0, Math.ceil((items.length * 3) / itemsPerSlide) - 1) + 1;
    };
    getNumberOfStraightSlides = () => {
        const { items = [], itemsPerSlide } = this.props;
        return Math.max(0, Math.ceil((items.length) / itemsPerSlide) - 1) + 1;
    };
    setActive = i => {
        const { hoverTimeout } = this.props;
        this.timeoutLeave && clearTimeout(this.timeoutLeave);
        this.timeoutEnter = setTimeout(() => this.setState({ active: i }), hoverTimeout);
        if (this.props.onHover) {
            this.props.onHover();
        }
        // this.setState({ active: i });
        // this.timeout = setTimeout(() => this.setState({ active: i }), 300);
    };
    removeActive = () => {
        const { hoverTimeout } = this.props;
        this.timeoutEnter && clearTimeout(this.timeoutEnter);
        this.timeoutLeave = setTimeout(() => this.setState({ active: null }), hoverTimeout);
        // this.setState({ active: null });
    };
    setHovered = () => {
        const { hoverTimeout } = this.props;
        this.hoverLeave && clearTimeout(this.hoverLeave);
        this.hoverEnter = setTimeout(() => this.setState({ hovered: this.props.hovered }), hoverTimeout);
        if (this.props.onHover) {
            this.props.onHover();
        }
    };
    removeHovered = () => {
        const { hoverTimeout } = this.props;
        this.hoverEnter && clearTimeout(this.hoverEnter);
        this.hoverLeave = setTimeout(() => this.setState({ hovered: this.props.hovered }), hoverTimeout);
    };
    toggleActive = i => {
        if (this.state.active === i) {
            this.removeActive();
        } else {
            this.setActive(i);
        }
    };
    render() {
        const {
            items,
            itemsPerSlide,
            itemProps,
            scale,
            scaleActiveBy,
            navPadding,
            spaceBetween,
            speedSlide,
            speedMove,
            hovered,
            itemContainerCls,
            backgroundColor,
            renderItem: SliderItemInner,
            renderHandlePrev: SliderHandlePrevInner,
            renderHandleNext: SliderHandleNextInner,
        } = this.props;

        const itemWidth = +(this.state.width / itemsPerSlide).toFixed(2);
        const itemHeight = itemWidth * (9 / 16);
        const { slideIndex, positionIndex } = this.state;
        const itemWidthPercent = +(100 / itemsPerSlide).toFixed(6);
        const firstIsActive =
            Number.isInteger(this.state.active) && Number.isInteger(this.state.active / itemsPerSlide);
        const lastIsActive =
            Number.isInteger(this.state.active) &&
            Number.isInteger((this.state.active + 1) / itemsPerSlide);
        let itemsToFill = items.length - (items.length % itemsPerSlide);
        let itemCount = items.length * 3;
        let startSlideNumber = positionIndex * itemsPerSlide;
        let startingItem = startSlideNumber % items.length;
        if (startingItem < 0) {
            startingItem = items.length - startingItem;
        }
        if (startingItem < 0) {
            startingItem = 0;
        }
        let list_of_items = [];
        for (let i = 0; i < itemsPerSlide * 3; i++) {
            list_of_items.push(items[(startingItem + i + itemsPerSlide) % items.length]);
        }
        let scroll = -this.state.width;
        if (slideIndex > positionIndex) {
            scroll -= this.state.width;
        }
        else if (slideIndex < positionIndex) {
            scroll += this.state.width;
        }

        return (
            <React.Fragment>
                <InlineSlider navPadding={navPadding}
                    itemHeight={itemHeight}
                    onVisible={() => {
                        this.onSetSizeOnVisible();
                    }}
                    onMouseEnter={() => this.setHovered()}
                    onMouseLeave={() => this.removeHovered()}
                    zIndex={this.state.hovered ? 2 : 1}>
                    <SliderHandlePrev
                        backgroundColor={backgroundColor}
                        spaceBetween={spaceBetween}
                        width={navPadding}
                        disabled={!this.infiniteScrolling && this.state.scroll === this.state.startPosition}
                    >
                        <SliderHandlePrevInner
                            {...{
                                goToPrev: this.goToPrev,
                                disabled: this.state.disableNextPrev,
                            }}
                        />
                    </SliderHandlePrev>
                    <SliderHandleNext
                        backgroundColor={backgroundColor}
                        spaceBetween={spaceBetween}
                        width={navPadding}
                    >
                        <SliderHandleNextInner
                            {...{
                                goToNext: this.goToNext,
                                disabled: this.state.disableNextPrev,
                            }}
                        />
                    </SliderHandleNext>
                    <SliderInner
                        speedSlide={this.state.jumpTo ? 0 : speedSlide}
                        spaceBetween={spaceBetween}
                        height={itemHeight}
                        x={scroll}
                        innerRef={r => {
                            this.sliderInnerRef = r;
                        }}
                    >
                        {list_of_items.filter(x => x).map((item, index) => {

                            return (
                                <SliderItemHolder
                                    height={itemHeight}
                                    index={index}
                                    itemCount={itemCount}
                                    itemWidth={itemWidth}
                                    itemsPerSlide={itemsPerSlide}
                                    slideIndex={slideIndex}
                                    slideOffset={slideIndex * this.state.width}
                                >
                                    <SliderItem
                                        key={[this.id, index].join('.')}
                                        speedMove={speedMove}
                                        spaceBetween={spaceBetween}
                                        width={itemWidth}
                                        height={itemHeight}
                                        widthPercent={100}//,//itemWidthPercent
                                        scaleActiveBy={scaleActiveBy}
                                        scale={scale}
                                        translateLeft={Number.isInteger(this.state.active) && this.state.active > index}
                                        translateRight={Number.isInteger(this.state.active) && this.state.active < index}
                                        firstIsActive={firstIsActive}
                                        lastIsActive={lastIsActive}
                                        isFirst={Number.isInteger(index / itemsPerSlide)}
                                        isLast={Number.isInteger((index + 1) / itemsPerSlide)}
                                        isActive={this.state.active === index}
                                        index={index}
                                    >
                                        <SliderItemVisibility
                                            width={itemWidth}
                                            disableVisibilityChange={this.state.disableNextPrev}
                                            height={itemHeight}>
                                            <SliderItemInner
                                                {...itemProps(index)}
                                                {...{
                                                    item,
                                                    itemContainerCls,
                                                    index,
                                                    speedMove,
                                                    scaleActiveBy,
                                                    spaceBetween: spaceBetween,
                                                    width: itemWidth,
                                                    widthPercent: 100,//itemWidthPercent
                                                    active: this.state.active === index,
                                                    setActive: () => this.setActive(index),
                                                    removeActive: this.removeActive,
                                                    toggleActive: () => this.toggleActive(index),
                                                }}
                                            />
                                        </SliderItemVisibility>
                                    </SliderItem>
                                </SliderItemHolder>
                            )
                        })}
                    </SliderInner>
                </InlineSlider>
            </React.Fragment>
        );
    }
}
(Lolomo as any).defaultProps = {
    hoverTimeout: 200,
    backgroundColor: 'black',
    hovered: false,
    items: [],
    itemCls: '',
    itemsPerSlide: 8,
    scaleActiveBy: 2.2,
    spaceBetween: 16,
    navPadding: 80,
    speedSlide: 540,
    speedMove: 540,
    itemProps: () => ({}),
    scale: true,
    renderItem: ({ item: { color, component }, index, setActive, removeActive, itemContainerCls }) => (
        <ItemDefault
            onMouseEnter={setActive}
            onMouseLeave={removeActive}
            className={itemContainerCls}
            style={{
                backgroundColor: color,
            }}
        >   {component}
        </ItemDefault>
    ),
    renderHandlePrev: ({ goToPrev, ...p }) => (
        <SliderHandleDefault {...p} onClick={goToPrev}>
            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-chevron-left"
                width="72" height="72" viewBox="0 0 24 24"
                strokeWidth="2.5" stroke="#fd0061" fill="none"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <polyline points="15 6 9 12 15 18" />
            </svg>
        </SliderHandleDefault>
    ),
    renderHandleNext: ({ goToNext, ...p }) => (
        <SliderHandleDefault {...p} onClick={goToNext}>
            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-chevron-right"
                width="72" height="72" viewBox="0 0 24 24"
                strokeWidth="2.5" stroke="#fd0061" fill="none"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <polyline points="9 6 15 12 9 18" />
            </svg>
        </SliderHandleDefault>
    ),
};

const ItemDefault = styled.div<{ height?: number }>`
  flex: 1;
  ${({ height }) => height === undefined ? '' : `height: ${height} px;`}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  position: relative;
  cursor: pointer;
  user-select: none;
`;

interface SliderInterface {
    navPadding: number;
    zIndex: number;
}
const Slider = styled.div<SliderInterface>`
  position: relative;
  width: 100%;
  max-width: 100%;
  padding: 0 ${({ navPadding }) => navPadding}px;
  z-index: ${({ zIndex }) => zIndex || '1'};
`;
export function SliderItemVisibility(props: {
    height: number,
    width: number,
    disableVisibilityChange: boolean,
    children: any
}) {
    const [hasBeenVisible, setHasBeenVisible] = useState(false);
    const [reference, visible] = useElementOnScreen({
        root: null,
        rootMargin: '200px',
        threshold: 0
    });
    useEffect(() => {
        if (visible) {
            setHasBeenVisible(true);
        }
    }, [visible])
    const { height, width } = props;
    return (
        <div ref={reference} className="SliderItemVisibility" style={{ height, width, opacity: visible ? 1 : 0 }}>
            {visible || hasBeenVisible || props.disableVisibilityChange ? props.children : <div style={{ height, width }}></div>}
        </div>
    );
}
export function InlineSlider(props: {
    onMouseEnter: () => void,
    onMouseLeave: () => void,
    onVisible: () => void,
    children: any,
    navPadding: any,
    itemHeight: number,
    zIndex: any
}) {
    const { navPadding, zIndex } = props;
    const [hasBeenVisible, setHasBeenVisible] = useState(false);
    const [reference, visible] = useElementOnScreen({
        root: null,
        rootMargin: '200px',
        threshold: 0
    });
    useEffect(() => {
        let timeout = setTimeout(() => {
            if (!hasBeenVisible && visible && props.onVisible) {
                props.onVisible()
            }
            if (visible) {
                setHasBeenVisible(true);
            }
        }, 100);
        return () => {
            clearTimeout(timeout);
        }
    }, [visible])
    return (
        <div ref={reference} style={{
            position: 'relative',
            width: '100%',
            maxWidth: `100%`,
            padding: `0 ${navPadding}px`,
            zIndex: zIndex || '1'
        }} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave}>
            {visible || hasBeenVisible ? props.children : <div style={{ height: props.itemHeight }}></div>}
        </div>
    );
}
interface SliderInnerInterface {
    speedSlide: number;
    height: number
    spaceBetween: number;
    x: number
}
const SliderInner = styled.div<SliderInnerInterface>`
  white-space: nowrap;
  transition: transform ${({ speedSlide }) => speedSlide}ms cubic-bezier(0.5, 0, 0.1, 1);
  transform: translate3d(${({ x = 0 }) => x}px, 0, 0);
  backface-visibility: hidden;
  overflow-x: visible;
  position: relative;
  display: flex;
  flex-direction: row;
  height: ${({ height }) => height}px;
  margin: 0 -${({ spaceBetween }) => spaceBetween}px;
`;
interface SlideHandleInterface {
    width: number
}
const SliderHandle = styled.div<SlideHandleInterface>`
  position: absolute;
  top: 0;
  bottom: 0;
  width: ${({ width }) => width}px;
  cursor: pointer;
  z-index: 1;
`;
interface SliderHandleBtn {
    disabled?: boolean;
    spaceBetween: number;
    backgroundColor: string;
}
const SliderHandlePrev = styled(SliderHandle) <SliderHandleBtn>`
  left: 0;
  margin-left: -${({ spaceBetween }) => spaceBetween * 2}px;
  background-color: rgba(20, 20, 20, 0.5);
  opacity: .1;
  transition: all .3s;
  &:hover {
      opacity: 1;
  }
`;
const SliderHandleNext = styled(SliderHandle) <SliderHandleBtn>`
  right: 0;
  margin-right: -${({ spaceBetween }) => spaceBetween * 2}px;
  background-color: rgba(20, 20, 20, 0.5);
  opacity: .1;
  transition: all .3s;
  &:hover {
      opacity: 1;
  }
`;
interface SlideHandleDefaultInterface {
    disabled?: boolean
}
const SliderHandleDefault = styled.div<SlideHandleDefaultInterface>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  transition: background-color 200ms ease;
  color: rgba(255, 255, 255, 1);
  width: 100%;
  height: 100%;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  ${({ disabled }) =>
        disabled &&
        `
    color: transparent;
    background-color: transparent;
  `};
`;
interface SliderItemInterface {
    speedMove: number;
    widthPercent: number;
    spaceBetween: number;
    translateLeft: boolean;
    translateRight: boolean;
    firstIsActive: boolean;
    lastIsActive: boolean;
    isActive: boolean;
    index: number;
    width: number;
    height: number;
    scaleActiveBy: number;
    isFirst: boolean;
    isLast: boolean;
    scale: boolean
}
export function SliderItemHolder(props: {
    index: number,
    itemCount: number,
    itemWidth: number,
    slideIndex: number,
    slideOffset: number,
    itemsPerSlide: number,
    height: number,
    children: any
}) {
    const {
        index,
        itemCount,
        itemWidth,
        slideIndex,
        itemsPerSlide,
        slideOffset,
        height
    } = props;
    const [trinaryOffset, setTrinaryOffset] = useState(null);
    const [xTranslation, setXTranslation] = useState(null);

    useEffect(() => {
        let globalItemIndex = slideIndex * itemsPerSlide;

        let itemWindowIndex = Math.floor(globalItemIndex / itemCount); // The items arrays global index
        let itemsGlobalIndex = (itemWindowIndex * itemCount) + (index); // The items 
        if ((itemsGlobalIndex < globalItemIndex) && Math.abs(globalItemIndex - itemsGlobalIndex) >= (itemCount / 3)) {
            itemsGlobalIndex += itemCount
        }
        setXTranslation(slideOffset + ((itemsGlobalIndex - globalItemIndex) * itemWidth));
    }, [slideIndex, itemWidth, itemCount, slideOffset]);

    useEffect(() => {
        let value = 1;
        if ((index / itemCount) < (1 / 3)) {
            value = -1;
        }
        else if ((index / itemCount) < (2 / 3)) {
            value = 0;
        }
        setTrinaryOffset(value);
    }, [index, itemCount]);

    if (trinaryOffset === null) {
        return <></>
    }

    return (
        <div style={{
            // position: 'absolute',
            width: itemWidth,
            height,
            top: 0,
            left: xTranslation
        }}>
            <div style={{
                position: 'relative',
                width: itemWidth,
                height
            }}>
                {/* <div style={{ position: 'absolute', top: 0, left: 0, zIndex: 10000 }}><h1>{slideIndex}|{index}|{itemsPerSlide}</h1></div> */}
                {props.children}
            </div>
        </div>
    );
}
const SliderItem = styled.div<SliderItemInterface>`
  display: inline-flex;
  position: relative;
  white-space: normal;
  vertical-align: top;
  position: relative;
  transition: transform ${({ speedMove }) => speedMove}ms cubic-bezier(0.5, 0, 0.1, 1),
    max-width ${({ speedMove }) => speedMove}ms cubic-bezier(0.5, 0, 0.1, 1);
  width: 100%;
  height: ${({ height }) => height}px;
  max-width: ${({ widthPercent }) => widthPercent}%;
  padding: 0 ${({ spaceBetween }) => spaceBetween}px;
  ${({
    translateLeft,
    translateRight,
    firstIsActive,
    lastIsActive,
    isActive,
    index,
    width,
    widthPercent,
    scaleActiveBy,
    spaceBetween,
    isFirst,
    isLast,
    scale,
}) => {
        if (!scale) return '';
        let transform = '';
        if (translateLeft) {
            if (firstIsActive) {
                transform += `
        transform: translate3d(0, 0, 0);
        `;
            } else if (lastIsActive) {
                transform += `
        transform: translate3d(-${width * (scaleActiveBy - 1)}px, 0, 0);
        `;
            } else {
                transform += `
        transform: translate3d(-${(width * (scaleActiveBy - 1)) / 2}px, 0, 0);
        `;
            }
        }
        if (translateRight) {
            if (lastIsActive) {
                transform += `
        transform: translate3d(0, 0, 0);
        `;
            } else if (firstIsActive) {
                transform += `
          transform: translate3d(${width * (scaleActiveBy - 1)}px, 0, 0);
          `;
            } else {
                transform += `
          transform: translate3d(${(width * (scaleActiveBy - 1)) / 2}px, 0, 0);
        `;
            }
        }
        if (isActive) {
            transform += `
        transform: scale(${scaleActiveBy + spaceBetween / width});
        z-index: 1;
      `;
        }
        if (isFirst) {
            transform += `
        transform-origin: center left;
      `;
        }
        if (isLast) {
            transform += `
        transform-origin: center right;
      `;
        }
        return transform;
    }};
`;
